import WorkspacePreview from "../../../../src/components/WorkspacePreview";
import * as React from 'react';
export default {
  WorkspacePreview,
  React
};